<template>
  <b-form>
    <b-row>
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="activityTable"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(raterId)="data">
            <b-link
              :to="{ name: 'userprofile', params: { username: data.item.raterId.username } }"
            >
              {{ data.item.raterId.username }}
            </b-link>
          </template>
          <template #cell(number)="data">
            <b-form-rating
              id="rating-sm-no-border"
              v-model="data.item.number"
              no-border
              size="sm"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="dataMeta.currentPage"
                :total-rows="dataMeta.total"
                :per-page="dataMeta.perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="retrieveProfiles"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-row>
  </b-form>
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router'

import {
  BRow, BCol, BForm, BCard, BLink, BTable, BPagination, BFormRating,
} from 'bootstrap-vue'

export default {
  components: {
    BRow, BCol, BForm, BCard, BTable, BLink, BPagination, BFormRating,
  },
  data() {
    return {
      activityTable: null,
      searchQuery: '',
      dataMeta: {
        currentPage: 1,
        perPage: 14,
        total: 3,
      },
      tableColumns: [
        { key: '_id' },
        { key: 'raterId', label: 'Rated By', sortable: true },
        { key: 'number', label: 'Rate', sortable: true },
        { key: 'review', label: 'review', sortable: true },
        { key: 'createdAt', label: 'Date', sortable: true },
      ],
    }
  },
  mounted() {
    this.retrieveUserReviews()
  },
  methods: {
    ...mapActions({
      retrieveUserReviewsAction: 'profile/retrieveUserReviews',
    }),
    retrieveUserReviews() {
      const data = {
        id: router.currentRoute.params.id,
        page: this.dataMeta.currentPage,
        perPage: this.dataMeta.perPage,
        sortBy: 'createdAt',
        sortDesc: 1,
      }
      this.retrieveUserReviewsAction(data).then(response => {
        this.activityTable = response.data.data.reviews
        this.dataMeta.total = response.data.total
      })
    },

  },
}
</script>

<style>

</style>
